module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-arrow-up-fill-8a066045.svg";